// The automatic emails a school can switch off, by who gets them.
// Keys mirror School::NOTIFICATIONS; keep the copy true to when each
// email actually goes out (docs/BUSINESS_RULES.md §10).
export const NOTIFICATION_GROUPS = [
  {
    audience: "School admins",
    emails: [
      {
        key: "admin_daily_digest",
        name: "Daily campaign summary",
        when: "Each morning from the day donations open: yesterday's donations, and reading minutes once reading starts. Skipped after quiet days.",
      },
      { key: "admin_final_results", name: "Final results", when: "When donations close, after reading ends." },
    ],
  },
  {
    audience: "Teachers",
    emails: [
      { key: "teacher_reading_starts", name: "Reading starts today", when: "On the start date, with a link to their class." },
      { key: "teacher_weekly_digest", name: "Weekly classroom summary", when: "Monday mornings while the campaign runs: last week's minutes, donations and top readers." },
      { key: "teacher_reward_unlocked", name: "School reward unlocked", when: "When donations cross one of your school-wide fundraising rewards." },
      { key: "teacher_final_results", name: "Final results", when: "When donations close, after reading ends." },
    ],
  },
  {
    audience: "Families",
    emails: [
      { key: "parent_daily_digest", name: "Daily reading update", when: "The morning after any day with reading or donations for their child, from the day donations open, with progress toward prizes." },
      { key: "parent_wrapping_up", name: "Reading is wrapping up", when: "When reading ends: a last chance to log minutes and share their page." },
      { key: "parent_final_results", name: "Final results", when: "When donations close, after reading ends." },
    ],
  },
];
